import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WhatsappVideoComponent } from './whatsapp-video.component';

const routes: Routes = [{ path: '', component: WhatsappVideoComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WhatsappVideoRoutingModule { }
